import { SearchBarAction } from "../actions/search-bar"
import { SearchBarState } from "../common/types"

const initialState: SearchBarState = {
    searchTerm: "",
    cicoVisible: false,
    fancySearchTerm: { term: "", category: "", doFilter: true },
    extraTimelineVisible: false,
    isFancySearchVisible: false,
    placeholdersVisible: true,
    nonExceptionRowsVisible: true,
}

const searchBar = (state = initialState, action: SearchBarAction): SearchBarState => {
    switch (action.type) {
        case "SET_SEARCH_TERM":
            return { ...state, searchTerm: action.searchTerm }
        case "SET_FANCY_SEARCH_TERM":
            return { ...state, fancySearchTerm: action.searchTerm }
        case "TOGGLE_FANCY_SEARCH_VISIBLE":
            return { ...state, isFancySearchVisible: !state.isFancySearchVisible }
        case "TOGGLE_SEARCH_BAR_STATE":
            return {
                ...state,
                [action.attr]: !state[action.attr],
            }
        case "TOGGLE_PLACEHOLDERS_VISIBLE":
            return { ...state, placeholdersVisible: !state.placeholdersVisible }
        case "TOGGLE_NON_EXCEPTION_ROWS_VISIBLE":
            return { ...state, nonExceptionRowsVisible: !state.nonExceptionRowsVisible }
        case "TOGGLE_CICO_VISIBLE":
            return { ...state, cicoVisible: !state.cicoVisible }
        default:
            return state
    }
}

export default searchBar
